var _rect, _mask, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleChrome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 19,
    width: 62,
    height: 62
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 31,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9213 19V57.0455H37.8008L50 35.9091H81V19H23.9213Z",
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9213 19V57.0455H37.8008L50 35.9091H81V19H23.9213Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1284 56.9045L24.1009 32.8443L23.8966 33.1966L37.8254 57.0807L38.1284 56.9045Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 81H48.5099L62.2062 67.3036V57.0455H37.7938L19 24.8055V81Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 81H48.5099L62.2062 67.3036V57.0455H37.7938L19 24.8055V81Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9068 57.5034L61.6144 57.3343L48.0872 80.9894H48.4923L61.9139 57.514L61.9068 57.5034Z",
    fill: "#263238",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 35.9091L62.2063 57.0455L48.5099 81H81V35.9091H50Z",
    fill: "#FFCD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 35.9091L62.2063 57.0455L48.5099 81H81V35.9091H50Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 35.9091L62.2063 57.0455L48.5099 81H81V35.9091H50Z",
    fill: "#FFCD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 35.9091L62.2063 57.0455L48.5099 81H81V35.9091H50Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9213 19V57.0455H37.8008L50 35.9091H81V19H23.9213Z",
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9213 19V57.0455H37.8008L50 35.9091H81V19H23.9213Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 35.9091V43.2892L77.6182 35.9091H50Z",
    fill: "url(#paint5_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5099 81H19V24.8055L37.7938 57.0455H62.2062L48.5099 81Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9212 33.2494L44.0888 53.4135L37.7973 57.0455L23.9212 33.2494Z",
    fill: "url(#paint6_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.531 80.9648L55.9146 53.417L62.2062 57.0455L48.531 80.9648Z",
    fill: "url(#paint7_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 64.0909C57.7822 64.0909 64.0909 57.7822 64.0909 50C64.0909 42.2178 57.7822 35.9091 50 35.9091C42.2178 35.9091 35.9091 42.2178 35.9091 50C35.9091 57.7822 42.2178 64.0909 50 64.0909Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 61.2727C56.2257 61.2727 61.2727 56.2258 61.2727 50C61.2727 43.7742 56.2257 38.7273 50 38.7273C43.7742 38.7273 38.7273 43.7742 38.7273 50C38.7273 56.2258 43.7742 61.2727 50 61.2727Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 35.5568C42.2148 35.5568 35.9091 41.8625 35.9091 49.6477V50C35.9091 42.2148 42.2148 35.9091 50 35.9091H81V35.5568H50Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1886 57.0455C59.7509 61.2516 55.2136 64.0909 50 64.0909C44.7864 64.0909 40.242 61.2516 37.8114 57.0455H37.7973L19 24.8055V25.1577L37.8114 57.3977C40.2491 61.6039 44.7864 64.4432 50 64.4432C55.2136 64.4432 59.7509 61.6074 62.1886 57.3977H62.2062V57.0455H62.1851H62.1886Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M50.3523 35.9091C50.2924 35.9091 50.236 35.9161 50.1761 35.9197C57.8768 36.0148 64.0909 42.2782 64.0909 50C64.0909 57.7218 57.8768 63.9852 50.1761 64.0803C50.236 64.0803 50.2924 64.0909 50.3523 64.0909C58.1375 64.0909 64.4432 57.7852 64.4432 50C64.4432 42.2148 58.1375 35.9091 50.3523 35.9091Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3295 57.5034C63.5273 55.432 64.2213 53.0366 64.2213 50.472C64.2221 49.0269 63.9999 47.5904 63.5625 46.2131C63.8972 47.4178 64.0909 48.679 64.0909 49.993C64.0909 52.5575 63.3969 54.953 62.1992 57.0243L62.2063 57.0384L48.5099 80.993H48.9185L62.3295 57.5034Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 19.3523C67.0606 19.3523 80.9014 33.1367 81 50.1761C81 50.1162 81.0035 50.0599 81.0035 50C81.0035 32.8795 67.124 19 50.0035 19C32.8831 19 19 32.8795 19 50C19 50.0599 19.0035 50.1162 19.0035 50.1761C19.0986 33.1367 32.9394 19.3523 50 19.3523Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 80.6477C67.0606 80.6477 80.9014 66.8633 81 49.8239C81 49.8838 81.0035 49.9401 81.0035 50C81.0035 67.1205 67.124 81 50.0035 81C32.8831 81 19 67.1205 19 50C19 49.9401 19.0035 49.8838 19.0035 49.8239C19.0986 66.8633 32.9394 80.6477 50.0035 80.6477H50Z",
    fill: "black",
    fillOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 26.5175,
    y1: 42.6093,
    x2: 45.0118,
    y2: 31.8051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 55.2489,
    y1: 74.1307,
    x2: 34.6902,
    y2: 62.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#055524",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 59.1239,
    y1: 33.725,
    x2: 64.3023,
    y2: 56.3761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EA6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 59.1239,
    y1: 33.725,
    x2: 64.3023,
    y2: 56.3761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EA6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 26.5175,
    y1: 42.6093,
    x2: 45.0118,
    y2: 31.8051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6614 35.8915) scale(29.6191)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.8966 33.2741) scale(27.4914)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9295 50.0493) scale(30.9542)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleChrome);
export default __webpack_public_path__ + "static/media/GoogleChrome.691cf1de53e6019de5314bcbc65b40fe.svg";
export { ForwardRef as ReactComponent };